module.exports = __webpack_public_path__ + "img/stepsBg.538dc28b.jpg";